import { Injectable, HostListener } from '@angular/core';
import { HTTP } from '@ionic-native/http/ngx';
import { NgxXml2jsonService } from 'ngx-xml2json';
import { Constants, StatusCode, Dictionary } from '../data-model/constant.model';
import { AlertController, LoadingController, NavController, Platform } from '@ionic/angular';
import { Observable, forkJoin } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Headers, RequestOptions } from '@angular/http';
import { BasePagePage } from '../shared/base-page/base-page.page';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  public alertPresented: any;
  private data = [];
  resObject: any;
  films: Observable<any>;
  public innerWidth: any;
  public innerHeight: any;

  constructor(
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    public navCtrl: NavController,
    public http: HTTP,
    public ngxXml2jsonService: NgxXml2jsonService,
    public httpClient: HttpClient,
    public plt: Platform) {

    // super(loadingCtrl, alertCtrl);

    this.alertPresented = false;

    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;

  }

  setData(id, data) {
    this.data[id] = data;
  }

  getData(id) {
    return this.data[id];
  }

  async callWebService(webServiceName: any, postData: any, callback: (response: any) => void): Promise<any> {

    const url = Constants.k_BASE_WS_URL + '/' + webServiceName;
    console.log('\n\n', 'WEB SERVICE: ', url, '\n\n');
    console.log('\n\n', 'POST DATA: ', JSON.stringify([postData]), '\n\n');

    // Http Options
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     'Accept': 'application/json',
    //     'Content-Type': 'application/json',
    //     'Access-Control-Allow-Origin': '*',
    //     'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, PUT'
    //   })
    // }

    // if (webServiceName == Constants.k_POST_EMAIL) {

    //   this.httpClient.get('./assets/downloadcsv.txt', {
    //     responseType: 'text'
    //   }).subscribe(
    //     data => {

    //       const parser = new DOMParser();
    //       const xml = parser.parseFromString(data, 'text/xml');
    //       const obj = this.ngxXml2jsonService.xmlToJson(xml);
    //       const arr = JSON.parse(obj['string']);
    //       const resItem = arr[0];

    //       console.log('resItem: ', resItem)

    //       callback(resItem);

    //     },
    //     err => console.log('something went wrong: ', err)
    //   );

    //   return;

    // }

    // console.log('-------------------CHECK-------------------');

    // this.presentLoading(webServiceName);
    // this.presentLoading();

    let res = await this.http.sendRequest(url, {
      method: 'post',
      data: { vstrPostData: JSON.stringify([postData]) },
      headers: {},
      // timeout: 60000
    }).then(async response => {
      // prints 200
      const parser = new DOMParser();
      const xml = parser.parseFromString(response.data, 'text/xml');
      const obj = this.ngxXml2jsonService.xmlToJson(xml);
      const arr = JSON.parse(obj['string']);
      const resItem = arr[0];
      console.log('REQUEST: ', JSON.stringify([postData]));
      console.log('\n\n', webServiceName, '\t\t', 'RESPONSE ITEM: ', resItem, '\n\n');

      // if (needShowLoad == true) {
      //   this.dismissLoading(webServiceName);
      // }

      setTimeout(() => {
        callback(resItem);
      }, 250);

      if (!resItem || !resItem.status_code || resItem.status_code != StatusCode.Success) {
        let strCode = Constants.d_WS_STATUS[resItem.status_code];
        let strDesc = resItem.status_desc;
        let strData = resItem.data;
        var strMsg = '';
        if (strData && strData != '-') {
          strMsg = strDesc + '<br/><br/>' + strData;
        } else {
          strMsg = strDesc;
        }
        setTimeout(() => {
          BasePagePage.presentAlert(strCode, strMsg, (res) => {
            if (res.role = Constants.b_OK && resItem.status_code == StatusCode.InvalidAccessToken) {
              this.navCtrl.navigateRoot('/logout');
            }
          });
        }, 500);

      }

    }).catch(async response => {
      // prints 403
      console.log('catch error: ', response);
      // prints Permission denied
      // if (needShowLoad == true) {
      //   this.dismissLoading(webServiceName);
      // }

      setTimeout(() => {
        callback(response.error);
      }, 250);

      setTimeout(() => {
        BasePagePage.presentAlert('Error ' + response.status, response.error + '<br/><br/>Please try again later. Thanks.');
      }, 500);

    });

    return res;

  }

  async callWebServiceSimultaneously(arrResponse: Array<Promise<any>>, callback?: (response: any) => void): Promise<any> {

    this.presentLoading();

    return await forkJoin(arrResponse).subscribe((result) => {

      setTimeout(() => {
        this.dismissLoading().then(() => {
          if (callback) {
            setTimeout(() => {
              callback(true);
            }, 600);
          }
        });
      }, 300);

    });

  }

  // getWebService(webServiceName: any, postData: any, callback: (response: any) => void) {

  //   console.log('GET WEB SERVICE: ', webServiceName);
  //   console.log('GET DATA: ', postData);

  //   this.http.get(Constants.k_BASE_WS_URL + '/' + webServiceName, { vstrPostData: JSON.stringify([postData]) }, {})
  //     .then(response => {
  //       // prints 200
  //       console.log(response.data);
  //       const parser = new DOMParser();
  //       const xml = parser.parseFromString(response.data, 'text/xml');
  //       const obj = this.ngxXml2jsonService.xmlToJson(xml);
  //       const arr = JSON.parse(obj['string']);
  //       const resItem = arr[0];
  //       console.log('GET RESPONSE ITEM: ', resItem);

  //       if (resItem.status_code != StatusCode.Success) {
  //         this.presentAlert(Constants.d_WS_STATUS[resItem.status_code], resItem.status_desc)
  //       }

  //       callback(resItem);

  //     })
  //     .catch(response => {
  //       // prints 403
  //       console.log(response.status);

  //       // prints Permission denied
  //       console.log(response.error);
  //       // callback(response.error);
  //     });

  // }

  public isDesktop() {

    /**
     * LIST UPDATED AS 2020-05-13
     * Platform Name	Description
          android	a device running Android
          capacitor	a device running Capacitor
          cordova	a device running Cordova
          desktop	a desktop device
          electron	a desktop device running Electron
          hybrid	a device running Capacitor or Cordova
          ios	a device running iOS
          ipad	an iPad device
          iphone	an iPhone device
          mobile	a mobile device
          phablet	a phablet device
          pwa	a PWA app
          tablet	a tablet device
     * 
     */

    let platforms = this.plt.platforms();
    let desktops = ['desktop', 'electron'];
    let filters = platforms.filter((platform) => desktops.includes(platform));

    if (filters.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  public screenSize(): Dictionary<any> {
    this.plt.ready().then((readySource) => {
      // console.log('Width: ' + this.plt.width());
      // console.log('Height: ' + this.plt.height());
    });
    return {
      'screenWidth': this.plt.width(),
      'screenHeight': this.plt.height()
    }
  }

  async presentLoading(): Promise<any> {

    if (this.loadingCtrl.getTop() != null && this.loadingCtrl.getTop()['__zone_symbol__value'] != undefined) {
      this.dismissLoading();
    }

    return await this.loadingCtrl.create({
      // duration: this.loadingDuration,
    }).then(a => {
      console.log('presentation: ', a);
      a.present().then(() => {
        console.log('presented');
        // a.dismiss();
      });
    })

  }

  async dismissLoading(): Promise<any> {

    return await this.loadingCtrl.dismiss().then(async () => {
      // if (this.loadingCtrl.getTop() != null && this.loadingCtrl.getTop()['__zone_symbol__value'] != undefined) {
      //   console.log('dismissed: ', this.loadingCtrl.getTop());
      //   await this.loadingCtrl.dismiss();
      // }
    }).catch((error) => {
      console.log('DISMISS ERROR: ', error);
    });

  }

}

interface LoginResponse {
  status_code: StatusCode
  status_desc: string
  accesstoken: string
}

export interface Device {
  name: string;
  value: string;
}